import { AlignLeft, Menu } from 'lucide-react'
import { useThemeStore } from '@/stores/themeStore'
import { WabaSwitcher } from './WabaSwitcher'
import { ThemeToggle } from './ThemeToggle'
import { UserMenu } from './UserMenu'
import { NotificationPanel } from './NotificationPanel'
import { useWaba } from '@/hooks/useWaba'

interface HeaderProps {
  onMenuClick?: () => void
}

// 64px white bar with a small shadow and no border. The nav toggle lives at
// the start; WABA switcher, notifications and the user menu sit at the end.
export function Header({ onMenuClick }: HeaderProps) {
  const { hasWaba } = useWaba()
  const { sidebarCollapsed, toggleSidebar } = useThemeStore()

  return (
    <header className="header-surface sticky top-0 z-30 flex w-full shrink-0 print:hidden">
      <div className="relative flex h-16 w-full min-w-0 items-center justify-between gap-2 px-4">
        {/* Start */}
        <div className="flex shrink-0 items-center gap-2">
          {/* Mobile: opens the nav drawer */}
          <button
            type="button"
            className="header-action-item lg:hidden"
            onClick={onMenuClick}
            aria-label="Open menu"
          >
            <Menu className="h-6 w-6" />
          </button>
          {/* Desktop: collapses / expands the side nav */}
          <button
            type="button"
            className="header-action-item hidden lg:block"
            onClick={toggleSidebar}
            aria-label={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {sidebarCollapsed ? <Menu className="h-6 w-6" /> : <AlignLeft className="h-6 w-6" />}
          </button>
        </div>

        {/* End */}
        <div className="flex min-w-0 items-center gap-1 sm:gap-2">
          {hasWaba && <WabaSwitcher />}
          <ThemeToggle />
          <NotificationPanel />
          <UserMenu />
        </div>
      </div>
    </header>
  )
}
